import { motion } from "framer-motion";
import { stats } from "../../lib/content";
import { Building2, Layers, Compass, Users } from "lucide-react";

const icons = [Layers, Building2, Compass, Users];

export default function StatsSection() {
    return (
        <section className="relative py-24 md:py-32" data-testid="stats-section">
            <div className="max-w-7xl mx-auto px-6 md:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
                    <div className="lg:col-span-5">
                        <div className="inline-flex items-center gap-2 text-xs font-mono tracking-[0.2em] uppercase text-cyan-400 mb-6">
                            <span className="w-8 h-px bg-cyan-400/60" /> About PES
                        </div>
                        <div className="text-sm md:text-base font-medium text-cyan-200/80 tracking-wide mb-6">
                            Professional Engineering Solutions <span className="text-white font-semibold">(PES)</span>
                        </div>
                        <h2 className="font-heading font-black text-white text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tighter">
                            A decade of precision in MEP design.
                        </h2>
                        <p className="mt-8 text-lg text-slate-400 leading-relaxed max-w-md">
                            Founded on the belief that great engineering is invisible until it's indispensable,
                            PES partners with owners, architects and contractors to deliver systems that simply
                            work — beautifully, efficiently, and for decades.
                        </p>
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-2 gap-4">
                        {stats.map((s, i) => {
                            const Icon = icons[i];
                            return (
                                <motion.div
                                    key={i}
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    viewport={{ once: true, margin: "-80px" }}
                                    transition={{ duration: 0.5, delay: i * 0.1 }}
                                    className="relative group p-8 rounded-2xl bg-slate-900/40 backdrop-blur-xl border border-white/5 hover:border-blue-500/30 transition-colors duration-500 overflow-hidden"
                                    data-testid={`stat-card-${i}`}
                                >
                                    <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full bg-blue-500/5 blur-3xl group-hover:bg-blue-500/20 transition-colors duration-500" />
                                    <Icon className="w-5 h-5 text-cyan-400 mb-6" />
                                    <div className="font-heading font-black text-white text-5xl md:text-6xl tracking-tighter leading-none">
                                        {s.value}
                                        {s.suffix && <span className="text-cyan-400 text-3xl md:text-4xl">{s.suffix}</span>}
                                    </div>
                                    <div className="mt-4 text-sm text-slate-400 leading-snug">{s.label}</div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </section>
    );
}
